<template>
  <div class="company-contain">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <div class="search-company-box">   
      <div class="pledge-box1-top">
        <label class="el-radio"> 
          <span class="el-radio-input is-checked" :class="{'is-checked': reporting}" @click="reporting=true, curDateType = finance[0][0]"> 
            <span class="el-radio-inner"></span> 
            <input class="el-radio-original" value="按报告期" type="radio">
          </span> 
          <span class="el-radio-label">按报告期</span> 
        </label>
        <label class="el-radio"> 
          <span class="el-radio-input" :class="{'is-checked': !reporting}" @click="reporting=false, curDateType = yearList[0][0]"> 
            <span class="el-radio-inner"></span> 
            <input class="el-radio-original" value="按年度" type="radio">
          </span> 
          <span class="el-radio-label">按年度</span> 
        </label>

        <div class="Quarterly-Report">
          <div class="head-title" @click.stop="showDateDropmemu($event)">
            {{ curDateType }}
            <span class="close-bot" @click.stop="showDateDropmemu($event)"></span>
          </div>
          <ul class="menu-lanmu" v-show="dateDropmenu && reporting">
            <li v-for="h in finance">
              <a href="javascript:;" v-if="curDateType != h[0]" @click="clickDropmenu(), curDateType = h[0]">{{ h[0] }}</a>
            </li>   
          </ul>
           <ul class="menu-lanmu" v-show="dateDropmenu && !reporting">  
            <li v-for="h in yearList">
              <a href="javascript:;" v-if="curDateType != h[0]" @click="clickDropmenu(), curDateType = h[0]">{{ h[0] }}</a>
            </li>   
          </ul>
        </div>
      </div>

      <div class="Single-list-main" v-if="reporting">  
        <ul class="Single-list-box">
          <li v-for="(key, val) in llb" track-by="$index">
            <p class="date">{{ key }}</p> 
            <template  v-for="v in finance">
              <p class="time" v-if="v[0] == curDateType"> {{ v[1][val] ? v[1][val] : '--' | money }} </p>
            </template>
          </li> 
        </ul>   
      </div>

      <div class="Single-list-main" v-if="!reporting">  
        <ul class="Single-list-box">
          <li v-for="(key, val) in llb" track-by="$index">
            <p class="date">{{ key }}</p> 
            <template  v-for="v in yearList">
              <p class="time" v-if="v[0] == curDateType"> {{ v[1][val] ? v[1][val] : '--' | money }} </p>
            </template>
          </li>  
        </ul>   
      </div>

      <!-- <div class="Single-list-main" v-if="!llb.length"> 
        <div class="Block-trade-no">暂无数据</div>
      </div>  -->

    </div>
  </div>

  <!--微信绑定弹框-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
    <div class="binding-content">
      <a class="binding-logo"></a>
      <div class="binding-text">
        立即绑定IBDATA账号<br/>成为金融分析高手
      </div>
      <div class="binding-bot">
        <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
        <a class="binding-btn" @click="goBindPage">立即绑定</a>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
  <!-- / 微信绑定弹框-->
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import echartMix from '../../common/echartMix'
  import echarts from 'echarts'
  import wxshareMix from '../../common/wxshareMix'

  export default {
    name: 'FinanceView',
    mixins: [userMix, searchMix, comSearchMix, companyMix, echartMix, wxshareMix],
    data () {
      return {
        reporting: true,    //按报告期
        curDateType: '',
        yearList: [],
        finance: [],
        llb:{'销售商品、提供劳务收到的现金(元)': 'sellingreceived', '收到其他与经营活动有关的现金(元)': 'otherrelatedreceived', '经营活动现金流入小计(元)': 'cashflowoperations', '购买商品、接受劳务支付的现金(元)': 'payincash', '支付给职工以及为职工支付的现金(元)': 'payworkercash', '支付的各项税费(元)': 'taxpayments', '支付其他与经营活动有关的现金(元)': 'payrelatedcash', '经营活动现金流出小计(元)': 'cashoutoperatingactivites', '经营活动产生的现金流量净额(元)': 'cashoperatingactivites', '处置固定资产、无形资产和其他长期资产收回的现金净额(元)': 'cashdisposeassets', '收到其他与投资活动有关的现金(元)': 'cashotherinvestment', '投资活动现金流入小计(元)': 'cashinflowinvestment', '购建固定资产、无形资产和其他长期资产支付的现金(元)': 'payforassets', '投资支付的现金(元)': 'payforinvestment', '取得子公司及其他营业单位支付的现金净额(元)': 'payforrelated', '投资活动现金流出小计(元)': 'cashoutflowinvestment', '投资活动产生的现金流量净额(元)': 'cashflowinvestment', '吸收投资收到的现金(元)': 'cashreceivedinvestors', '子公司吸收少数股东投资收到的现金(元)': 'cashreceivedinvestorssub', '取得借款收到的现金(元)': 'cashreceiveddebts', '收到其他与筹资活动有关的现金(元)': 'cashreceivedotherfinancing', '筹资活动现金流入小计(元)': 'cashinflowfinancing', '偿还债务支付的现金(元)': 'cashrepaymentsborrowed', '分配股利、利润或偿付利息支付的现金(元)': 'cashpaymentsinterests', '支付其他与筹资活动有关的现金(元)': 'payotherfinancing', '筹资活动现金流出小计(元)': 'cashoutflowfinancing', '筹资活动产生的现金流量净额(元)': 'cashflowfinancing', '汇率变动对现金及现金等价物的影响(元)': 'cashexchange', '现金及现金等价物净增加额(元)': 'cashadd', '期初现金及现金等价物余额(元)': 'cashlastbalance', '期末现金及现金等价物余额(元)': 'cashbalance', '净利润(元)': 'retainedprofits', '资产减值准备(元)': 'preparationimpairmentassets', '固定资产和投资性房地产折旧(元)': 'assetsdepreciationtotal', '固定资产折旧、油气资产折耗、生产性生物资产折旧(元)': 'assetsdepreciation', '无形资产摊销(元)': 'amortizationintangibleassets', '长期待摊费用摊销(元)': 'amortisationlongtermprepaidexpenses', '处置固定资产、无形资产和其他长期资产的损失(元)': 'disposalassetsloss', '财务费用(元)': 'financialcost', '投资损失(元)': 'investmentloss', '递延所得税(元)': 'deferredtaxassetstotal', '递延所得税资产减少(元)': 'deferredtaxassets', '存货的减少(元)': 'decreaseinventory', '经营性应收项目的减少(元)': 'decreasebusinessreceivables', '经营性应付项目的增加(元)': 'increasebusinesspay', '其他(元)': 'othercash', '现金的期末余额(元)': 'cashbalancetotal', '现金的期初余额(元)': 'cashlastbalancetotal', '现金及现金等价物的净增加额(元)': 'cashadd2'},
          gbllb:{
            // 投资活动产生的现金流量净额(元)
            // 投资活动产生的现金流量净额其他项目(元)
            '投资活动产生的现金流量净额其他项目(元)':'othercashinvestmentnet',
            '经营活动产生的现金(元)':'cashbusiness',
            '出售物业、厂房及设备的亏损(收益)(元)':'saleofequipment',
            '预付款项、按金及其他应收款项减少(增加)(元)':'otherreceivableschange',
            '已付股息(融资)(元)':'paiddividend',
            '购买证券投资所支付的现金(元)':'cashpaidsecuritiesinvestment',
            '投资活动产生的现金流量净额(元)':'cashinvestmentnet',
            '融资活动产生的现金流量净额其他项目(元)':'cashfinancingnet',
            '已收利息及股息(投资)(元)':'receivedinterestdividends',
            '存货的减少(增加)(元)':'inventorychange',
            '折旧与摊销(元)':'depreciationamortization',
            '利息支出(元)':'interestexpense',
            '回购股份(元)':'sharebuyback',
            '经营活动产生的现金流量净额其他项目(元)':'othercashoperatingnet',
            '现金及现金等价物净增加额其他项目(元)':'cashincreasenet',
            '预收账款、按金及其他应付款增加(减少)(元)':'otherpayablechange',
            '偿还借款(元)':'repaymentloan',
            '已收利息(经营)(元)':'receivedinterestbusiness',
            '应付帐款增加(减少)(元)':'payablechange',
            '出售无形资产及其他资产收到的现金(元)':'cashreceivedotherassets',
            '现金及现金等价物的期末余额其他项目(元)':'othercashbalanceending',
            '吸收投资所得(元)':'incomefrominvestment',
            '购买子公司、联营企业及合营企业支付的现金(元)':'cashpaidjointcompany',
            '经营活动产生的现金流量净额其他项目(元)':'cashoperatingnet',
            '融资活动产生的现金流量净额其他项目(元)':'othercashfinancingnet',
            '发行债券(元)':'issuebonds',
            '出售子公司、联营企业及合营企业收到的现金(元)':'cashreceivedjointcompany',
            '已付税项(元)':'taxpaid',
            '资产减值准备(元)':'impairmentofassets',
            '利息收入(元)':'interestincome',
            '除税前利润(元)':'profitbeforetax',
            '现金及现金等价物的期初余额(元)':'cashbalanceinitial',
            '发行费用(元)':'distributionfee',
            '发行股份(元)':'issuedshares',
            '现金及现金等价物净增加额其他项目(元)':'othercashincreasenet',
            '重估盈余(元)':'revaluationearnings',
            '应收帐款减少(增加)(元)':'receivablechange',
            '出售物业、厂房及设备的亏损(收益)(元)':'equipment',
            '赎回/偿还债券(元)':'redemptionbond',
            '购买无形资产及其他资产支付的现金(元)':'cashpaidotherassets',
            '汇率变动对现金及现金等价物的影响(元)':'casheffectsexchange',
            '已付利息(融资)(元)':'paidinterest',
            '投资亏损(收益)(元)':'investmentincome',
            '经营资金变动其他项目(元)':'otheroperatingchange',
            '已付利息(经营)(元)':'payedinterestbusiness',
            '购买物业、厂房及设备支付的现金(元)':'cashpaidequipment',
            '应占联营及合营公司亏损(收益)(元)':'jointcompanyincome',
            '新增借款(元)':'newloans',
            '现金及现金等价物的期末余额其他项目(元)':'cashbalanceending',
            '出售证券投资所收到的现金(元)':'cashreceivedsecuritiesinvestment',
            '出售物业、厂房及设备收到的现金(元)':'cashreceivedequipment'
        },
        dataMap: {'年一季报': '-03-31', '年中报': '-06-30', '年三季报': '-09-30', '年年报': '-12-31'},
      }
    },
    route: {
      data({to}) {
        if(to.query.stype == 6){
          this.llb = this.gbllb
        }
        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query.share)
          }
        }

        if (this.currentuser) { 
          this.queryParam = to.query;
          this.companycode = to.query.companycode;
          this.stype = to.query.stype;

          // 微信签名 分享
          let title = decodeURIComponent(to.query.desc);
          let desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
          document.title = title;
          this.getwxsign()    // 微信签名
          this.shareCompany(title, desc);
          
          this.setSelectedTab();
          this.getFinance();
        }
      }
    },
    methods: {
      getFinance: function() {

        let query = {};
        query.code = this.companycode;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid
        this.loading = true;

        $.ajax({
          url: apiUrl('/V1.0.0/company/finance'),
          method: 'post',
          dataType: 'json',
          // async: false,
          // data: JSON.stringify({'code': this.companycode})
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            if (Object.keys(response.data).length) {

              let arr = []
              for (let k in response.data) {
                if (k.indexOf('年') >= 0) {
                  let n  = k.substr(0, 4) + this.dataMap[k.substr(4)]
                  arr.push([n, response.data[k]])
                } else {
                  arr.push([k, response.data[k]])
                }
              }

              arr.sort(function (a, b) {
                return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g,''))
              })
              if (arr.length > 6) {
                for (let i = 0; i<6;i++) {
                  this.finance.push(arr[i])
                }
              } else {
                this.finance = arr
              }
              for (let i of arr) {
                if (i[0].indexOf('-12-') >= 0) {
                  this.yearList.push(i)
                }
              }
              if (this.yearList.length > 5) {
                this.yearList = this.yearList.slice(0, 5)
              }

              // 初始按报告期
              this.reporting = true;
              this.curDateType = this.finance[0][0];
            }

          } else {
            alert(response.description)
          }
        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },

      showDateDropmemu: function() {
        this.dateDropmenu = this.dateDropmenu ? false : true;
      },
      clickDropmenu: function() {
        this.dateDropmenu = false;
      },
    }
  }
</script>

<style scoped>
  /* 加载 */
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .Quarterly-Report .head-title {
    display: block;
  }
</style>


/** WEBPACK FOOTER **
 ** Llb.vue?b864e664
 **/